import { Observable } from 'rxjs';
import { FieldModel } from '../../models';

export abstract class BaseFieldsOptionsService {
  public abstract getFields();
  public abstract getInstitutionFields();
  public abstract getMedicalSchoolFields();
  public abstract getProgramFields();
  public abstract getSurveyFields(surveyYear: string);
  public abstract getVacantPositionFields();
  public abstract getSpecialtyFields(): Observable<FieldModel[]>;
  public abstract getVideoSeriesFields();
  public abstract getRemoteVideoFields();
}
